import { useQuery } from '@tanstack/react-query'
import { APP_NAME } from '@zet/end-points'
import { useUserContext } from '@zet/feature-user'
import { isApp } from '@zet/utils'

import { getExperimentForZetBanner, getZetReferralData } from './functions'

function useGetZetReferralData(userId: number | undefined) {
  return useQuery(
    ['zetReferralData', userId],
    () => getZetReferralData(userId),
    { enabled: !!userId && isApp && APP_NAME === 'zet-app' },
  )
}
function useGetExperimentForZetBanner() {
  const { data: userContext } = useUserContext(APP_NAME === 'zet-app' && isApp)
  return useQuery(
    ['experimentForZetBanner', userContext?.id],
    () => getExperimentForZetBanner(userContext?.id),
    {
      enabled: !!userContext?.id && isApp && APP_NAME === 'zet-app',
    },
  )
}
export { useGetExperimentForZetBanner, useGetZetReferralData }
